import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_TOKEN_BUTTON: `${cleanedFilename(__filename)}-add-token-button`,
  EMPTY_STATE: `${cleanedFilename(__filename)}-add-empty-state`,
  ADD_TOKEN_MODAL: `${cleanedFilename(__filename)}-add-token-modal`,
  EDIT_TOKEN_MODAL: `${cleanedFilename(__filename)}-edit-token-modal`,
};
